exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-report[data-v-412e48e5] {\n    min-width: 120px;\n    border-top: none !important;\n    border-left: none !important;\n    border-right: none !important;\n    border-bottom: 1px solid !important;\n}\n", ""]);

// exports
